import React, { useState, useEffect } from "react";
import axios from "axios";
import colors from "../Constant/colors.js";
import LoadingButton from "./LoadingButton.jsx"; 
function OldPaper() {
  const [classes, setClasses] = useState([]);
  const [sections, setSections] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [papers, setPapers] = useState([]);

  const [selectedClass, setSelectedClass] = useState("");
  const [selectedSection, setSelectedSection] = useState("");
  const [selectedSubject, setSelectedSubject] = useState("");

  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [file, setFile] = useState(null);

  const [isEditing, setIsEditing] = useState(false);
  const [currentPaperId, setCurrentPaperId] = useState(null);

  // Get current session ID from localStorage
  const currentSessionId = localStorage.getItem("currentSessionId");
  const[loading,setLoading]=useState(false);
  const labelStyle = "block text-black font-semibold text-[18px] mb-1";
  const inputStyle = {
    background: "#FFFFFF",
    border: "1px solid #1E40AF",
    padding: "12px",
    borderRadius: "8px",
    width: "100%",
    fontSize: "14px",
  };
  const buttonStyle = {
    background: colors.gradientPrimary,
    color: "white",
    padding: "12px 30px",
    borderRadius: "8px",
    fontWeight: "600",
    fontSize: "18px",
    display: "flex",
    justifyContent: "center",
    gap: "8px",
    alignItems: "center",
  };

  // ===================== FETCH DATA =====================

  useEffect(() => {
    if (!currentSessionId) return;
    fetchClasses();
    fetchPapers();
  }, [currentSessionId]);

  useEffect(() => {
    if (selectedClass) {
      fetchSections(selectedClass);
      fetchSubjects(selectedClass);
    } else {
      setSections([]);
      setSubjects([]);
    }
  }, [selectedClass]);

  const fetchClasses = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/classes/getClasses`,
        { params: { sessionId: currentSessionId } }
      );
      setClasses(res.data);
    } catch (err) {
      console.error("Error fetching classes:", err.response?.data || err.message);
    }
  };

  const fetchSections = async (className) => {
    try {
      const res = await axios.get(
        ` ${process.env.REACT_APP_API_BASE_URL}/api/sections/${className}/getSectionsByClassName`,
        { params: { sessionId: currentSessionId } }
      );
      setSections(res.data);
    } catch (err) {
      console.error("Error fetching sections:", err.response?.data || err.message);
    }
  };

  const fetchSubjects = async (className) => {
    try {
      const res = await axios.get(
        ` ${process.env.REACT_APP_API_BASE_URL}/api/subjects/getSubjectsByClassName/${className}`,
        { params: { sessionId: currentSessionId } }
      );
      setSubjects(res.data);
    } catch (err) {
      console.error("Error fetching subjects:", err.response?.data || err.message);
    }
  };

  const fetchPapers = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/papers/getPapersBySession`,
        { params: { sessionId: currentSessionId } }
      );
      setPapers(res.data);
    } catch (err) {
      console.error("Error fetching papers:", err.response?.data || err.message);
    }
  };

  // ===================== FORM HANDLERS =====================

  const resetForm = () => {
    setSelectedClass("");
    setSelectedSection("");
    setSelectedSubject("");
    setTitle("");
    setDescription("");
    setFile(null);
    setIsEditing(false);
    setCurrentPaperId(null);
  };

 const handleSubmit = async (e) => {
  e.preventDefault();
  setLoading(true);
  if (!selectedClass || !selectedSection || !selectedSubject || !title) {
  alert("Please fill all required fields.");
  setLoading(false);
  return;
}


  try {
    const formData = new FormData();
    formData.append("title", title);
    formData.append("description", description);
    formData.append("className", selectedClass);
    formData.append("sectionName", selectedSection);
    formData.append("subjectName", selectedSubject);
    formData.append("sessionId", currentSessionId); // must send session ID
    if (file) formData.append("paper", file); // field name matches backend

    let response;
    if (isEditing) {
      response = await axios.put(
        ` ${process.env.REACT_APP_API_BASE_URL}/api/papers/updatePaper/${currentPaperId}`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );
    } else {
      response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/papers/createPaper`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );
    }

    console.log("Paper saved:", response.data);
    resetForm();
    fetchPapers();
  } catch (err) {
    console.error("Error saving paper:", err.response?.data || err.message);
    alert("Error saving paper: " + (err.response?.data?.error || err.message));
  }finally{
    setLoading(false);
  }
};


  const handleEditClick = (paper) => {
    setSelectedClass(paper.className);
    setSelectedSection(paper.sectionName);
    setSelectedSubject(paper.subjectName);
    setTitle(paper.title);
    setDescription(paper.description);
    setIsEditing(true);
    setCurrentPaperId(paper._id);
  };

  const handleDeleteClick = async (paperId) => {
    if (!window.confirm("Are you sure?")) return;
    try {
      await axios.delete(` ${process.env.REACT_APP_API_BASE_URL}/api/papers/deletePaper/${paperId}`);
      fetchPapers();
    } catch (err) {
      console.error("Error deleting paper:", err.response?.data || err.message);
    }
  };

  // ===================== JSX =====================

  return (
    <div className="min-h-screen bg-white p-6">
      <h2 className="font-bold text-black mb-4 text-[18px]">
        {isEditing ? "Edit Paper" : "Upload New Paper"}
      </h2>

      <form onSubmit={handleSubmit} className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10">
        {/* Class */}
        <div>
          <label className={labelStyle}>Class</label>
          <select
            value={selectedClass}
            onChange={(e) => setSelectedClass(e.target.value)}
            style={inputStyle}
          >
            <option value="">Select Class</option>
            {classes.map((c) => (
              <option key={c._id} value={c.className}>{c.className}</option>
            ))}
          </select>
        </div>

        {/* Section */}
        <div>
          <label className={labelStyle}>Section</label>
          <select
            value={selectedSection}
            onChange={(e) => setSelectedSection(e.target.value)}
            disabled={!selectedClass}
            style={inputStyle}
          >
            <option value="">Select Section</option>
            {sections.map((s) => (
              <option key={s._id} value={s.sectionName}>{s.sectionName}</option>
            ))}
          </select>
        </div>

        {/* Subject */}
        <div>
          <label className={labelStyle}>Subject</label>
          <select
            value={selectedSubject}
            onChange={(e) => setSelectedSubject(e.target.value)}
            disabled={!selectedSection}
            style={inputStyle}
          >
            <option value="">Select Subject</option>
            {subjects.map((sub) => (
              <option key={sub._id} value={sub.subjectName}>{sub.subjectName}</option>
            ))}
          </select>
        </div>

        {/* Title */}
        <div className="md:col-span-2">
          <label className={labelStyle}>Title</label>
          <input
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            style={inputStyle}
          />
        </div>

        {/* File Upload */}
        <div>
          <label className={labelStyle}>Upload Paper</label>
          <input
            type="file"
            onChange={(e) => setFile(e.target.files[0])}
            style={inputStyle}
          />
        </div>

        {/* Description */}
        <div className="md:col-span-3">
          <label className={labelStyle}>Description</label>
          <textarea
            rows="3"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            style={inputStyle}
          />
        </div>

        {/* Buttons */}
        <div className="md:col-span-3 flex justify-center gap-4 mt-4">
          <LoadingButton
  type="submit"
  loading={loading}
  text={isEditing ? "Update Paper" : "Upload Paper"}
  style={buttonStyle}
/>

          <button
            type="button"
            onClick={resetForm}
            style={{ ...buttonStyle, background: "white", color: "black", border: "1px solid #ccc" }}
          >
            Reset
          </button>
        </div>
      </form>

      {/* Papers Table */}
      <div className="overflow-x-auto mt-8">
        <table className="min-w-full border border-gray-300 text-center">
          <thead className="bg-gray-200">
            <tr>
              {["#", "Title", "Class (Section)", "Subject", "Actions"].map((head) => (
                <th key={head} className="py-3 px-4 border-b text-black font-semibold text-[18px]">{head}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {papers.length ? papers.map((paper, i) => (
              <tr key={paper._id} className="even:bg-gray-50">
                <td className="border px-4 py-2 text-[14px]">{i + 1}</td>
                <td className="border px-4 py-2 text-[14px]">{paper.title}</td>
                <td className="border px-4 py-2 text-[14px]">{paper.className} ({paper.sectionName})</td>
                <td className="border px-4 py-2 text-[14px]">
                  {paper.subjectName} <br />
                  {paper.paperFile && (
                    <a
                      href={`${paper.paperFile}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-blue-600 underline text-[14px]"
                    >
                      View/Download
                    </a>
                  )}
                </td>
                <td className="border px-4 py-2 flex flex-col md:flex-row gap-2 justify-center">
                  <button
                    onClick={() => handleEditClick(paper)}
                    className="px-3 py-1 rounded text-white bg-yellow-500 text-[14px]"
                  >
                    Edit
                  </button>
                  <button
                    onClick={() => handleDeleteClick(paper._id)}
                    className="px-3 py-1 rounded text-white bg-red-600 text-[14px]"
                  >
                    Delete
                  </button>
                </td>
              </tr>
            )) : (
              <tr>
                <td colSpan="5" className="text-gray-500 py-4 text-[14px]">
                  No papers uploaded for this session.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default OldPaper;
